import { useRef } from 'react';
import { showSuccess, showError } from '@/utils/toastHelpers';
import { useMarkBibPickedUp } from '@/hooks/useRegistrations';
import { Registration } from './bibpickupmanager.props';

export const useBibPickupActions = (setSearchQuery: (q: string) => void) => {
  const markBibPickedUp = useMarkBibPickedUp();
  const searchInputRef = useRef<HTMLInputElement>(null);

  const handleBibPickup = async (registration: Registration) => {
    try {
      const updated: any = await markBibPickedUp.mutateAsync(registration.id);
      showSuccess(
        'Успешно!',
        `Број ${updated?.bibNumber ?? registration.bibNumber} — ${registration.firstName} ${registration.lastName} го презеде стартниот број.`
      );
      setSearchQuery('');
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    } catch (error: any) {
      const message = error.response?.data?.message || 'Неуспешно потврдување.';
      showError({ message });
    }
  };

  return {
    searchInputRef,
    handleBibPickup,
    isPending: markBibPickedUp.isPending,
  };
};
